import React from 'react';
import { getClassNames } from 'utils';

import './styles/Paragraph.css';
import './styles/Error.css';

const Error = (props) => (
    <div
        role="alert"
        className={getClassNames(
            'paragraph paragraph-error',
            props.className,
        )}
    >
        {props.children}
    </div>
);

export default Error;
